// SkuCatalogLayout — chrome for /admin/sku-catalog.
//
// Gated on userStore.isAdmin (Plex employee — @plexresearch.com OR `admins`
// Cognito group) OR sku-admin group. Soft gate (render a message) rather
// than redirect, so an admin who shares the URL gets a sensible page.

import {inject, observer} from "mobx-react";
import {Outlet} from "react-router-dom";

import {withAuthentication} from "../../components/AuthenticateUser";
import "../admin-entitlements/AdminEntitlements.css";  // reuse the page chrome

const SkuCatalogLayout = ({userStore}) => {
  const isSkuAdmin = userStore.userGroups?.includes("sku-admin");
  const allowed = userStore.isAdmin || isSkuAdmin;

  if (!allowed) {
    return (
      <div className="adminEnt stone-page">
        <div className="gate">
          <h2>SKU administrators only</h2>
          <p>
            This area manages the global Plex SKU catalog — the features that can
            be entitled to tenants and users. Only Plex employees can edit it.
          </p>
          <p style={{marginTop: 12}}>
            If you need access, ask a Plex admin to add you to the
            <strong> sku-admin </strong> Cognito group.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="adminEnt stone-page">
      <div className="adminEnt-shell" style={{gridTemplateColumns: "1fr"}}>
        <main className="adminEnt-page">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default withAuthentication(inject("userStore")(observer(SkuCatalogLayout)));
